import React, { useState } from "react";
import { Container, Form, Button } from "react-bootstrap";
import { Link, useSearchParams } from "react-router-dom";
import "./ChangePassword.css";
import illustration from "../../../assets/ilustracao.png";
import logo from "../../../assets/Logo.png";
import { resetPassword } from "../../../api/auth/reset_password";
import { useNavigate } from "react-router-dom";
import FlashMessage from "../../../components/common/FlashMessage";
import { useFlashMessage } from "../../../hooks/useFlashMessage";

const ChangePasswordPage: React.FC = () => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { message, type, showMessage, clearMessage } = useFlashMessage(5000);
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      showMessage("As senhas não coincidem", "warning");
      return;
    }

    setLoading(true);
    resetPassword(password, confirmPassword, token)
      .then(() => {
        showMessage("Senha alterada com sucesso.", "success");
        setTimeout(() => navigate("/"), 2000);
        return;
      })
      .catch((error) => {
        showMessage("Não foi possível redefinir a senha.", "error");
        setLoading(false);
      });
  };

  return (
    <Container fluid className="login-container">
      {message && (
        <div
          style={{
            position: "fixed",
            top: "20px",
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: 9999,
            minWidth: "400px",
          }}
        >
          <FlashMessage message={message} type={type} onClose={clearMessage} />
        </div>
      )}
      <div className="left-section">
        <div className="branding">
          {<img src={logo} alt="Logo" className="logo" />}
          <span className="brand-name">Insecta</span>
        </div>

        <div className="login-content">
          <h1 className="title">Altere sua senha</h1>
          <p className="subtitle title">
            Após alterar,{" "}
            <Link to="/" className="highlight">
              entre
            </Link>{" "}
            com seu e-
            <br />
            mail e sua nova senha.
          </p>
        </div>

        <div className="illustration-container">
          <img src={illustration} alt="Ilustração" className="illustration" />
        </div>
      </div>

      <div className="right-section">
        <div className="form-container">
          <p className="form-title">Insira suas informações abaixo</p>
          <Form onSubmit={handleSubmit} className="login-form">
            <Form.Group className="mb-3">
              <Form.Control
                type="password"
                placeholder="Senha"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="form-input"
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Control
                type="password"
                placeholder="Confirmar senha"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
                className="form-input"
              />
            </Form.Group>

            <Button type="submit" className="login-button" disabled={loading}>
              {loading ? (
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                  style={{ width: "1rem", height: "1rem" }}
                ></span>
              ) : (
                "Alterar senha"
              )}
            </Button>
          </Form>
        </div>
      </div>
    </Container>
  );
};

export default ChangePasswordPage;
